<template>
    <main-page :loading="loading">
        <div class="title text-center mt-4">
            <h1 class="font-weight-normal">
                <small class="text-gray" v-tr>Welcome to|Bienvenue sur</small>
                Eye-In Wireless
            </h1>
            <p class="lead">
                <span v-tr>Thank you for using our network|Merci d'utiliser notre réseau</span>
            </p>
        </div>

<!--        <div class="dealers card-container">-->
<!--            <h5 class="" v-tr>Our Partners|Nos partenaires</h5>-->
<!--            <b-row v-if="dealers">-->
<!--                <b-col md="3" v-for="dealer in dealers" v-bind:key="dealer.dealerid">-->
<!--                    <b-card img-top :img-src="dealer.cover_url" class="dealer">-->
<!--                        <h4 class="name" v-tr>{{ dealer.name }}</h4>-->
<!--                        <p class="description" v-tr>{{ dealer.description }}</p>-->
<!--                        <div class="action">-->
<!--                            <b-btn :href="dealer.website" v-if="dealer.website" target="_blank" size="sm" variant="outline-secondary">-->
<!--                                <span v-tr>Visit Website|Site internet</span>-->
<!--                            </b-btn>-->
<!--                            <b-btn :to="'/content/' + dealer.dealerid" size="sm" variant="outline-primary" class="ml-2">-->
<!--                                <span v-tr>View Offers|Voir les offres</span>-->
<!--                            </b-btn>-->
<!--                        </div>-->
<!--                    </b-card>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--        </div>-->

        <b-container>
            <b-card class="mx-auto my-5" style="width: 450px; max-width: 100%;">
                <h4 class="name" v-tr>Manage your account|Gérer votre compte</h4>
                <p class="description" v-tr>{{ user.email }}</p>
                <div class="action">
                    <b-btn :to="'/account/'" size="sm" variant="outline-primary" class="ml-2">
                        <span v-tr>My Account|Mon compte</span>
                    </b-btn>
                </div>
            </b-card>
        </b-container>
    </main-page>
</template>

<script>
import Network from "../../vue-components/helpers/Network.js";

export default {
    name: `home`,
    data() {
        return {
            loading: true,
            giftOpened: false,
            giftShaking: false,
            birthdayModal: false,
            showGift: false,
            dealers: null
        }
    },
    activated() {
        this.getDealers();
    },
    methods: {
        getDealers() {
            Network.get(`/wifi-portal/dealers`)
                .then(resp => {
                    this.dealers = resp.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.main-page {
    .title {
        h1 {
            font-size: 25pt;
        }

        .lead {
            font-size: 1.1rem;
            opacity: 0.5;
            font-weight: 500;
        }
    }

    .dealers,
    .offers {
        > .row {
            justify-content: center;
        }

        h5 {
            letter-spacing: 1px;
            font-size: 1rem;
            color: #444;
            text-transform: uppercase;
            text-align: center;
            margin-bottom: 0;
        }

        .dealer {
            .card-img-top {
                object-fit: cover;
                height: 200px;
            }

            .action {
                text-align: right;
            }
        }

        .offer {
            max-height: 250px;
            overflow: hidden;

            .card-img-left {
                height: 100%;
                min-height: 250px;
                width: 40%;
                object-fit: cover;
                border-top-left-radius: inherit;
                border-bottom-left-radius: inherit;
            }

            .card-body {
                padding: 1rem;
                display: flex;
                flex-direction: column;

                h4 {
                    font-size: 1.4rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    flex: 2;
                }

                .description {
                    height: 114px;
                    overflow: hidden;
                    font-size: 10pt;
                    flex: 4;
                }

                .action {
                    text-align: right;
                }
            }
        }

        .recommendation {
            text-align: center;
            font-size: 10pt;
            letter-spacing: 1px;
            font-weight: 500;
            color: #777;
            text-transform: uppercase;

            margin-top: 15px;

            .badge {
                width: 12px;
                height: 12px;
                margin-right: 5px;
                display: inline-block;
            }
        }
    }

    @media(max-width: 576px) {
        .title {
            h1 {
                font-size: 20pt;
            }

            .lead {
                font-size: 1rem;
                opacity: 0.5;
                font-weight: 500;
            }
        }

        .offers {
            & + .offers {
                margin-top: 25px;
            }

            h5 {
                margin-left: 0;
                font-size: 0.9rem;
                color: #333;
                text-align: center;
            }

            .card {
                margin-bottom: 0;
            }
        }
    }
}

#giftModal {
    .gift {
        display: block;
        margin: auto;
    }

    .gift:hover {
        cursor: pointer;
    }

    @keyframes jump {
        0% {
            transform: translate3d(0, -5%, 0) scale3d(1, 1, 1);
        }
        25% {
            transform: translate3d(0, 0%, 0) scale3d(.95, 1.05, 1);
        }
        50% {
            transform: translate3d(0, 5%, 0) scale3d(1.05, .95, 1);
        }
    }

    .jump {
        transform-origin: 50% 50%;
        animation: jump .5s linear alternate infinite;
    }

    @keyframes shake {
        0% {
            transform: translate(1px, 1px) rotate(0deg);
        }
        10% {
            transform: translate(-1px, -2px) rotate(-1deg);
        }
        20% {
            transform: translate(-3px, 0px) rotate(1deg);
        }
        30% {
            transform: translate(3px, 2px) rotate(0deg);
        }
        40% {
            transform: translate(1px, -1px) rotate(1deg);
        }
        50% {
            transform: translate(-1px, 2px) rotate(-1deg);
        }
        60% {
            transform: translate(-3px, 1px) rotate(0deg);
        }
        70% {
            transform: translate(3px, 1px) rotate(-1deg);
        }
        80% {
            transform: translate(-1px, -1px) rotate(1deg);
        }
        90% {
            transform: translate(1px, 2px) rotate(0deg);
        }
        100% {
            transform: translate(1px, -2px) rotate(-1deg);
        }
    }

    .shaking {
        animation: shake 0.5s;
        animation-iteration-count: infinite;
    }
}
</style>
